import { useMutation } from '@tanstack/react-query';
import { saveAudio } from '../../services';

export function useSaveAudio() {
  return useMutation(saveAudio, { onSuccess: (data) => data });
}
